import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Link from '../../Link';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbBrandLinkBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <Link to={props.attributes.ctaLink} className={`brand-link ${props.attributes.className ? props.attributes.className : ''} ${classes.brandLink} ${classes.brandLinkTheme}`}>
        {blocks[0]}
        <span className="button">{props.attributes.ctaText}</span>
    </Link>
};

export const CgbBrandLinkBlockFragment = graphql`
  fragment CgbBrandLinkBlock on WpBlock {
    ... on WpCgbBrandLinkBlock {
        name
        attributes {
            ctaLink
            ctaText
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBrandLinkBlockPreview = `
    ... on CgbBrandLinkBlock {
        name
        attributes {
            ctaLink
            ctaText
            className
        }
    }
`;